var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { Order } from 'app/orders/order.model';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { OnInit } from '@angular/core';
import { ButtonTypes } from 'app/ui/button/button.component';
import { OrderService } from 'app/orders/order.service';
// Компонент отображающий ошибки тасок
var OrderErrorsComponent = /** @class */ (function () {
    function OrderErrorsComponent(order, _dialogService, _orderService) {
        this.order = order;
        this._dialogService = _dialogService;
        this._orderService = _orderService;
        this.buttonTypes = ButtonTypes;
        // Список ошибок таски(order)
        this.errors = null;
        // Текст тултипа
        this.tooltipText = '';
        this.SUCCESSFUL_COPY = 'The log is copied';
        this.serverError = '';
    }
    OrderErrorsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._orderService.getError(this.order.id, this.order.application)
            .subscribe(function (response) {
            _this.errors = response.errors;
        }, function (err) {
            _this.serverError = "Server Error: " + err.status + " " + err.statusText;
        });
    };
    OrderErrorsComponent.prototype.showNoErrors = function () {
        return this.errors && this.errors.length === 0 && this.errors !== null && !this.showServerError();
    };
    OrderErrorsComponent.prototype.showSpinner = function () {
        return this.errors === null && !this.showServerError();
    };
    OrderErrorsComponent.prototype.showServerError = function () {
        return this.serverError;
    };
    // Получение строки с датой и временем.
    OrderErrorsComponent.prototype.getDate = function (date) {
        var tzoffset = (new Date()).getTimezoneOffset() * 60000;
        var ISOString = new Date(date.getTime() - tzoffset).toISOString().split('T');
        var fullDate = ISOString[0];
        var fullTime = ISOString[1].split('.')[0];
        return fullDate + ", " + fullTime;
    };
    // Обработчик закрытия модального окна
    OrderErrorsComponent.prototype.close = function () {
        this._dialogService.close();
    };
    // Обработчик копирования лога
    OrderErrorsComponent.prototype.copyLog = function () {
        var _this = this;
        if (!this.errors || !this.errors.length) {
            return;
        }
        var textArea = document.createElement('textarea');
        textArea.style.position = 'fixed';
        textArea.style.left = '0';
        textArea.style.top = '0';
        textArea.style.opacity = '0';
        textArea.value = this.getErrorsLog(this.errors);
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.tooltipText = this.SUCCESSFUL_COPY;
        setTimeout(function () {
            _this.tooltipText = '';
        }, 2000);
    };
    OrderErrorsComponent.prototype.getErrorsLog = function (errors) {
        var e_1, _a;
        var log = '';
        try {
            for (var _b = __values(this.errors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var error = _c.value;
                log += error.date.toISOString() + ": " + error.description.replace(/\n|\r/g, "") + "\n";
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return log;
    };
    return OrderErrorsComponent;
}());
export { OrderErrorsComponent };
